module.exports = __webpack_public_path__ + "img/20.434baa7f.webp";